import Container from 'react-bootstrap/Container';
import './Footer.scss';


export default function Footer() {
  return (
    <div className='footer' id="footer">
        <Container>
            <p>Made With ❤️ By Justin Tew</p>
        </Container>
    </div>
  )
}
